import { GENERATE_IDEAS_COMBINED } from "../configs/routes.js";
import api from "./api.js";

export const generateIdeasCombined = (payload) =>
    new Promise((resolve, reject) => {
        api
            .post(GENERATE_IDEAS_COMBINED, payload, { timeout: 120000 })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });
